import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "search-cars-wrapper bg-white50 w-100 pb-4 btn-filter-container position-sticky" }
const _hoisted_2 = { class: "search-truck-wrapper-top" }
const _hoisted_3 = { class: "search-truck-size-wrapper d-flex direction-column size" }
const _hoisted_4 = { class: "text-raleway-13 uppercase" }
const _hoisted_5 = { class: "d-flex" }
const _hoisted_6 = { class: "mr-1" }
const _hoisted_7 = { class: "mr-1" }
const _hoisted_8 = { class: "search-cars-manufacturer-wrapper axis" }
const _hoisted_9 = { class: "text-raleway-13 uppercase" }
const _hoisted_10 = { class: "search-m-input" }
const _hoisted_11 = { class: "d-flex direction-column manufacturer" }
const _hoisted_12 = { class: "text-raleway-13 uppercase" }
const _hoisted_13 = { class: "search-m-input" }
const _hoisted_14 = { class: "d-flex direction-column code" }
const _hoisted_15 = { class: "text-raleway-13 uppercase" }
const _hoisted_16 = { class: "search-m-input" }
const _hoisted_17 = { class: "d-flex direction-column tyre" }
const _hoisted_18 = { class: "text-raleway-13 uppercase" }
const _hoisted_19 = { class: "search-m-input" }
const _hoisted_20 = { class: "d-flex direction-column index" }
const _hoisted_21 = { class: "text-raleway-13 uppercase" }
const _hoisted_22 = { class: "search-m-input" }
const _hoisted_23 = { class: "d-flex bg-white50 w-100 a-i-center j-content-center btn-filter-container" }

import { ResetFormType, TruckTypeFilter } from "@/store/modules/newOrders/type";
import ContainerMargin from "@/components/marginType/marginTypeComponents.vue";
import SelectComponent from "@/components/select/SelectComponent.vue";
import SelectNumber from "@/components/select/SelectNumber.vue";
import { computed, onBeforeMount, ref } from "vue";
import { IStore } from "@/store/types/StoreType";

import { Field } from "vee-validate";
import { useStore } from "vuex";


export default /*#__PURE__*/_defineComponent({
  __name: 'filterTruckComponent',
  props: {
    resetForm: { type: Function }
  },
  setup(__props: any) {

const props = __props;

const updateAxis = (options: string) => (initialValues.value.axis = options);
const updateTypeOfOperation = (options: string) =>
  (initialValues.value.product__tbr__type_of_operation = options);
const updateBrand = (options: string) =>
  (initialValues.value.product__brand__id = options);
const updateWidth = (event: Event) =>
  (initialValues.value.width__icontains = (
    event.target as HTMLInputElement
  ).value);
const updateHeight = (event: Event) =>
  (initialValues.value.height = (event.target as HTMLInputElement).value);
const updateDiameter = (event: Event) =>
  (initialValues.value.diameter = (event.target as HTMLInputElement).value);

const store = useStore<IStore>();

  const filterChange = (filter: string) =>
  store.commit("updateSelectOrdersStateSelectFilter", filter);
const search = ref(computed<boolean>(() => store.getters.getSearchStateTruck));
const customerType = ref(
  computed<string>(() => store.getters.getUserCustomerTypeData)
);
const brands = ref(
  computed<{ id: number; name: string }[]>(
    () => store.getters.getBrandsArrayInTruck
  )
);
const axisTruck = ref(
  computed<{ id: number; name: string }[]>(() => [
    { id: 0, name: "No select" },
    { id: 1, name: "All position" },
    { id: 2, name: "Drive" },
    { id: 3, name: "Steer" },
    { id: 4, name: "Steer trailer" },
    { id: 5, name: "Trailer" },
  ])
);

const initialValues = ref<TruckTypeFilter>(
  store.getters.getValuesTruckNewOrders
);
onBeforeMount(() => {
  store.dispatch("GetBrandTruck");
});

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t("size")), 1),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(SelectNumber, {
              class: _normalizeClass('b-none'),
              onInput: updateWidth,
              name: 'product__tbr__width',
              placeholder: 'Width',
              "initial-value": initialValues.value.width__icontains
            }, null, 8, ["initial-value"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(SelectNumber, {
              class: _normalizeClass('b-none'),
              onInput: updateHeight,
              name: 'product__tbr__height',
              placeholder: 'Height',
              "initial-value": initialValues.value.height
            }, null, 8, ["initial-value"])
          ]),
          _createElementVNode("div", null, [
            _createVNode(SelectNumber, {
              class: _normalizeClass('b-none'),
              onInput: updateDiameter,
              name: 'product__tbr__diameter',
              placeholder: 'Diameter',
              "initial-value": initialValues.value.diameter
            }, null, 8, ["initial-value"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$t("Axis")), 1),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(SelectComponent, {
            options2: axisTruck.value,
            updateMyValueSelect: updateAxis,
            myValueSelect: 
              axisTruck.value.find(
                (axis) =>
                  axis.id === +initialValues.value.axis ||
                  axis.name === initialValues.value.axis
              )?.name
            ,
            size: 13,
            name: 'product__tbr__axis',
            class: _normalizeClass('b-none'),
            "key-or-value": true,
            options: [],
            default: ''
          }, null, 8, ["options2", "myValueSelect"])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.$t("Manufacturer")), 1),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(SelectComponent, {
            size: 13,
            "update-my-value-select": updateBrand,
            myValueSelect: 
              brands.value.find(
                (brand) =>
                  brand.id === +initialValues.value.product__brand__id ||
                  brand.name === initialValues.value.product__brand__id
              )?.name || 'All'
            ,
            options2: brands.value,
            name: 'product__brand__id',
            class: _normalizeClass('b-none'),
            "key-or-value": true,
            options: [],
            default: ''
          }, null, 8, ["myValueSelect", "options2"])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.$t("manufacturer's code")), 1),
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_unref(Field), {
            name: 'product__external_product_id__startswith',
            modelValue: initialValues.value.product__external_product_id__startswith,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((initialValues.value.product__external_product_id__startswith) = $event)),
            placeholder: 
              initialValues.value?.product__external_product_id__startswith
            ,
            class: "input b-none search-m-input"
          }, null, 8, ["modelValue", "placeholder"])
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.$t("Type of operation")), 1),
        _createElementVNode("div", _hoisted_19, [
          _createVNode(SelectComponent, {
            options2: [
              { id: -1, name: 'All' },
              { id: 0, name: 'No select' },
              { id: 1, name: 'City transit regional' },
              { id: 2, name: 'Long haul' },
              { id: 3, name: 'Long haul regional' },
              { id: 4, name: 'Mixed service' },
            ],
            updateMyValueSelect: updateTypeOfOperation,
            myValueSelect: 
              initialValues.value.product__tbr__type_of_operation || 'All'
            ,
            size: 13,
            name: 'product__tbr__type_of_operation',
            class: _normalizeClass('b-none'),
            "key-or-value": true,
            options: [],
            default: ''
          }, null, 8, ["myValueSelect"])
        ])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.$t("load index")), 1),
        _createElementVNode("div", _hoisted_22, [
          _createVNode(_unref(Field), {
            name: 'product__tbr__load_index',
            modelValue: initialValues.value.load_index__icontains,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((initialValues.value.load_index__icontains) = $event)),
            placeholder: '',
            class: "input b-none search-m-input"
          }, null, 8, ["modelValue"])
        ])
      ]),
      (customerType.value === 'Reseller')
        ? (_openBlock(), _createBlock(ContainerMargin, { key: 0 }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_23, [
      _createElementVNode("button", {
        onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (props?.resetForm()), ["stop"])),
        class: "btn btn-default-sm search-btn",
        type: "button"
      }, _toDisplayString(_ctx.$tc("Clear")), 1),
      _createElementVNode("button", {
        class: "btn btn-default-sm search-btn",
        type: "submit",
        onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => {
          filterChange('Truck');
          _unref(store).commit('setSearchStateTruck', true);
        }, ["stop"]))
      }, _toDisplayString(_ctx.$tc("Search")), 1)
    ])
  ], 512)), [
    [_vShow, search.value]
  ])
}
}

})